import { service, squibTestEndpoint, } from '@/services/app.service';
import location from '@/services/location.service';
// Models
import ItemModel from '@/models/ItemModel';
import OptionModel from '@/models/OptionModel';
var mockMenuJSON = require('@/mocks/MockMenuService.json');
var mockMenuOptionsJSON = require('@/mocks/MockMenuOptions.json');
var locationBase = location.base;
// Endpoints
var getItem = function (b, a) { return "/admin/squib_get_items?b=" + b + "&a=[" + a + "]"; };
// Response handlers
var handleResponseGetMenuItems = function (response, callback) {
    var baseURL = response.config.baseURL;
    var menu = response.data.body.menu;
    var items = menu.items_map;
    var itemKeys = Object.keys(items);
    var itemModels = itemKeys.map(function (key) {
        var item = Object.assign({ baseURL: baseURL }, items[key]);
        var menuItem = new ItemModel(item);
        return menuItem;
    });
    callback(itemModels);
};
var handleResponseGetMenuItem = function (response, callback) {
    console.log(response);
    console.log(callback);
};
// TODO this needs to handle real server response
var handleResponseGetItemOptions = function (response, callback) {
    var options = response; // <-- response won't be flat
    var optionKeys = Object.keys(options);
    var optionModels = optionKeys.map(function (key) {
        var option = new OptionModel(options[key]);
        return option;
    });
    callback(optionModels);
};
// Service functions
var menuService = {
    // TODO use localforage for large item sets
    getMenuItems: function (callback) {
        return service.get("/admin/" + squibTestEndpoint + "?b=" + locationBase).then(function (response) {
            handleResponseGetMenuItems(response, callback);
        }).catch(function (error) {
            // TODO: implement actual error handling
            console.error(error);
            // handleResponseGetMenuItems(mockMenuJSON, callback);
        });
    },
    // TODO: Endpoint is returning 404
    getMenuItem: function (id, callback) {
        var requestEndpoint = getItem(locationBase, id);
        return service.get(requestEndpoint).then(function (response) {
            handleResponseGetMenuItem(response, callback);
        }).catch(function (error) {
            console.error(error);
        });
    },
    getItemOptions: function (callback) {
        handleResponseGetItemOptions(mockMenuOptionsJSON, callback);
    },
};
export default menuService;



//////////////////
// WEBPACK FOOTER
// ./src/services/menu.service.ts
// module id = null
// module chunks = 